import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  Select,
  Input,
  Form,
  Row,
  Col,
  Card,
  Radio,
  message,
  Button,
  Tooltip,
} from "antd";
import { CALL_API } from "../../../Common/api";
import { ReactComponent as Back } from "../../../../src/assets/images/lets-icons_back.svg";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import styled from "styled-components";
import GoogleMapComponent from "../../../Reusablecomponents/GoogleMapComponent";
import { useNavigate, useLocation } from "react-router-dom";
import * as turf from "@turf/turf";
import { useSelector } from "react-redux";

const GreenRadio = styled(Radio)`
  .ant-radio-inner {
    border-color: green; // Change the border color
  }
  .ant-radio-checked .ant-radio-inner {
    background-color: green; // Change the background color when checked
    border-color: green; // Change the border color when checked
  }
  .ant-radio-wrapper {
    color: green; // Change the text color
  }
`;

const Styledashboard = styled.div`
  .title {
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 18px;
    color: #3d3d3d;
    height: 17px;
    margin-top: 6px;
  }
  .subtitle {
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    color: #6f6c6c;
  }
  .box {
    border: 1px solid #e0e0e0; /* correct border syntax */
    border-radius: 6px;
    padding: 14px 10px;
    margin-bottom: 16px; /* add some spacing between sections */
    background: #fff; /* keep it white for card look */
  }
  .mapcomponent_subcontainer {
    height: calc(100vh - 100px); /* adjust header/footer */
    width: 100%;
    position: relative;
  }
  .container_for_header_subtwo {
    display: flex;
    align-items: center; /* Ensures all items align properly */
    gap: 10px; /* Adds spacing between elements */
    flex-wrap: wrap;
  }
  @media (min-width: 1026px) and (max-width: 1440px) {
    .mapboxgl-map {
      width: 30%;
    }
    .container_map_component {
      background-color:;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
    .map_container_three {
      width: 100% !important ;
    }
  }
  @media (max-width: 768px) {
    .mapboxgl-map {
      width: 40%;
      border-radius: 12px;
    }
  }

  @media (max-width: 1024px) {
    .mapboxgl-map {
      width: 40%;
    }
    .container_map_component {
      background-color:;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
  }
`;
const { Option } = Select;

function GeoDetails() {
  const [form] = Form.useForm();
  const location = useLocation();
  const [Reciepenttype, setReciepenttype] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const updateAllowed = useMemo(
    () => hasPermission("GEO", "UF"),
    [reduxPermissions],
  );
  // const Reciepenttype = [
  //   {
  //     name: "Consignor",
  //     value: 1,
  //     GUID: "d947bc56-14ab-4a1e-abd5-61d62d48c461",
  //   },
  //   {
  //     name: "Transporter",
  //     value: 2,
  //     GUID: "b7da9541-84c8-49a4-9fd3-550633598f5f",
  //   },
  //   {
  //     name: "Consignee",
  //     value: 3,
  //     GUID: "8c6159ce-50f1-4789-9e00-861f250c419e",
  //   },
  // ];
  const mode = location.state?.mode || "view"; // "add" | "edit" | "view"
  const fromEntityManagement = location.state?.fromEntityManagement || false; // flag to check if navigated from EntityManagement
  const [loading, setLoading] = useState(false);
  const [fenceList, setFenceList] = useState([]);
  const [resetCounter, setResetCounter] = useState(0);
  const [isEditing, setIsEditing] = useState(
    mode === "add" || (mode === "edit" && fromEntityManagement),
  );
  const [companyList, setCompanyList] = useState([]);
  const [currentFenceStyle, setCurrentFenceStyle] = useState(
    mode === "add" ? "1" : "2", // Default to Polygon for creation
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const fenceStyle = Form.useWatch("fstyle", form);

  const navigate = useNavigate();
  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`,
      );
      const data = await response.json();
      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };
  const fetchAllFenceTypes = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "geoFence/fence_types", {
        FAgentGUID: userInfo?.ECTSCompId,
      });
      setReciepenttype(data);
    } catch (error) {
      console.error("[fetchAllFenceTypes] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const handleSave = async () => {
    try {
      const values = await form.validateFields(); // get form values
      // map values to API structure
      const formData = {
        name: values.name,
        company: values.company,
        number: values.number,
        desc: values.desc,
        area: values.area,
        type: values.type,
        fpath: values.fpath,
        fstyle: values.fstyle,
        radius: values.radius,
        lng: values.lng,
        lat: values.lat,
        loc: values.loc,
      };
      const savedName = values.name;

      if (mode === "add") {
        await createFences(formData);
      } else {
        // updating → FGUID comes from existing record
        await updateFence(formData, fenceList?.FGUID);
      }
      setIsEditing(false);
      // Navigate back to EntityManagement if came from there, otherwise go to GeoFence
      if (fromEntityManagement) {
        const updatedEntityFormData = {
          ...(location.state?.entityFormData || {}),
          Consignorname: savedName, // Update both Consignorname (form field) and fence (state)
          fence: savedName,
          ENTID: location.state?.entityFormData?.ENTID,
          MCID: location.state?.entityFormData?.MCID,
        };
        navigate("/entitymanagement", {
          state: {
            returnFromGeoDetails: true,
            entityFormData: updatedEntityFormData,
            entityTabId: location.state?.entityTabId,
            entityIsEdit: location.state?.entityIsEdit ?? false,
          },
        });
      } else {
        navigate("/GeoFence");
      }
    } catch (err) {
      console.error("Error saving fence:", err);
    }
  };

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchAllCompany();
    fetchAllFenceTypes();
  }, []);
  useEffect(() => {
    if (location.state && companyList?.length) {
      setFenceList(location.state);

      // Update form values when fenceList changes
      form.setFieldsValue({
        name: location.state.FName || "",
        number: location.state.FNumber || "",
        company:
          userInfo?.MCID === 59
            ? "0f0f2e76-4733-4388-9242-9ed7db003a1e"
            : userInfo?.ECTSCompId || "",
        fstyle: location.state.FRadius === 0 ? "1" : "2",
        type:
          userInfo?.MCID === 55
            ? "cb092e5b-0367-46c3-98ef-89b779687efc" || ""
            : location.state.FFenceTypeGUID !== undefined
              ? String(location.state.FFenceTypeGUID)
              : undefined,
        lng: location.state.FCenterLon || "",
        lat: location.state.FCenterLat || "",
        area: location.state.FArea
          ? (location.state.FArea / 1000000).toFixed(3)
          : 0,
        radius: location.state.FRadius
          ? (location.state.FRadius / 1000).toFixed(2)
          : 0,
        loc: location.state.FAddress,
        desc: location.state.FRemark || "",
        fpath: location.state.FPath || "[]",
      });
    }
  }, [location.state, companyList, form]);

  const createFences = useCallback(
    async (formData) => {
      try {
        setLoading(true);
        // Find the GUID based on the selected type
        const fenceTypeGUID = formData.type || "";

        const { data, ResponseCode, message } = await CALL_API(
          "POST",
          "geoFence/create_fence",
          {
            FName: formData.name, //
            FNumber: formData.number, //
            FRemark: formData.desc,
            FArea: formData.area * 1_000_000, //
            FFormType: Number(formData.fstyle),
            FFenceTypeGUID: fenceTypeGUID,
            FPath: formData.fpath || "[]", //
            FRadius: formData.radius * 1000 || 0, //
            FCenterLon: formData.lng, //
            FCenterLat: formData.lat, //
            FAddress: formData.loc, //
            FAgentGUID: formData.company,
          },
        );
        if (ResponseCode === 200) {
          setLoading(false);
          message.success("Fence created successfully!");
          // Navigate back to EntityManagement if came from there, otherwise go to GeoFence
          if (fromEntityManagement) {
            const updatedEntityFormData = {
              ...(location.state?.entityFormData || {}),
              Consignorname: formData.name, // Update both Consignorname (form field) and fence (state)
              fence: formData.name,
              ENTID: location.state?.entityFormData?.ENTID,
              MCID: location.state?.entityFormData?.MCID,
            };
            navigate("/entitymanagement", {
              state: {
                returnFromGeoDetails: true,
                entityFormData: updatedEntityFormData,
                entityTabId: location.state?.entityTabId,
                entityIsEdit: location.state?.entityIsEdit ?? false,
              },
            });
          } else {
            navigate("/GeoFence");
          }
        } else {
          setLoading(false);
          console.warn("Creation failed", data);
          message.error(message);
        }
      } catch (error) {
        console.error("[createFences] error:", error);
      } finally {
        setLoading(false);
      }
    },
    [fromEntityManagement, location.state, navigate],
  );

  const updateFence = useCallback(
    async (formData, FGUID) => {
      try {
        setLoading(true);
        const fenceTypeGUID = formData.type || "";

        const {
          data,
          ResponseCode,
          message: apiMessage,
        } = await CALL_API("POST", "geoFence/update_fence", {
          FName: formData.name,
          FNumber: formData.number,
          FRemark: formData.desc,
          FArea: formData.area * 1_000_000, // convert back to m²
          FFormType: Number(formData.fstyle),
          FFenceTypeGUID: fenceTypeGUID,
          FPath: formData.fpath || "[]",
          FRadius: formData.radius * 1000 || 0, // convert km → meters
          FCenterLon: formData.lng,
          FCenterLat: formData.lat,
          FAddress: formData.loc,
          FAgentGUID: formData.company,
          FGUID, // existing fence ID
        });

        if (ResponseCode === 200) {
          message.success("Fence updated successfully!");
          // Navigate back to EntityManagement if came from there, otherwise go to GeoFence
          if (fromEntityManagement) {
            const updatedEntityFormData = {
              ...(location.state?.entityFormData || {}),
              fence: formData.name,
              ENTID: location.state?.entityFormData?.ENTID,
              MCID: location.state?.entityFormData?.MCID,
            };
            navigate("/entitymanagement", {
              state: {
                returnFromGeoDetails: true,
                entityFormData: updatedEntityFormData,
                entityTabId: location.state?.entityTabId,
                entityIsEdit: location.state?.entityIsEdit ?? false,
              },
            });
          } else {
            navigate("/GeoFence");
          }
        } else {
          message.error(apiMessage || "Update failed");
        }
      } catch (error) {
        console.error("[updateFence] error:", error);
      } finally {
        setLoading(false);
      }
    },
    [Reciepenttype, navigate, fromEntityManagement, location.state],
  );

  // For add mode, empty form, else fill with initialValues
  const getInitialFormValues = (data = {}) => ({
    FGUID: data.FGUID,
    name: data.FName || "",
    number: data.FNumber || "",
    company: data.FAgentGUID || "",
    fstyle: data.FRadius === 0 ? "1" : "2",
    type: data.FFormType !== undefined ? Number(data.FFormType) : undefined,
    lng: data.FCenterLon || "",
    lat: data.FCenterLat || "",
    area: data.FArea ? (data.FArea / 1000000).toFixed(3) : 0,
    radius: data.FRadius ? (data.FRadius / 1000).toFixed(2) : 0,
    loc: data.FAddress || "",
    desc: data.FRemark || "",
    fpath: data.FPath || "[]",
  });

  const initialValues = mode === "add" ? {} : getInitialFormValues(fenceList);

  useEffect(() => {
    if (location.state && companyList?.length) {
      setFenceList(location.state);

      const initialFenceStyle = location.state.FRadius === 0 ? "1" : "2";
      form.setFieldsValue({
        name: location.state.FName || "",
        number: location.state.FNumber || "",
        company:
          userInfo?.MCID === 59
            ? "0f0f2e76-4733-4388-9242-9ed7db003a1e"
            : userInfo?.ECTSCompId || "",
        fstyle: "1",
        type:
          userInfo?.MCID === 55
            ? "cb092e5b-0367-46c3-98ef-89b779687efc" || ""
            : location.state.FFenceTypeGUID !== undefined
              ? String(location.state.FFenceTypeGUID)
              : undefined,
        lng: location.state.FCenterLon || "",
        lat: location.state.FCenterLat || "",
        area: location.state.FArea
          ? (location.state.FArea / 1000000).toFixed(3)
          : 0,
        radius: location.state.FRadius
          ? (location.state.FRadius / 1000).toFixed(2)
          : 0,
        loc: location.state.FAddress,
        desc: location.state.FRemark || "",
        fpath: location.state.FPath || "[]",
      });

      setCurrentFenceStyle(initialFenceStyle);
      if (mode === "edit" && fromEntityManagement) {
        setIsEditing(true);
      }
    } else if (mode === "add") {
      // For creation, default to Polygon
      form.setFieldsValue({
        fstyle: "1",
      });
      setCurrentFenceStyle("1");
    }
  }, [location.state, companyList, form, mode, fromEntityManagement]);

  // Add a function to handle the change
  const handleFenceStyleChange = (e) => {
    const newStyle = e.target.value;
    setCurrentFenceStyle(newStyle);
    form.setFieldsValue({
      fstyle: newStyle,
      fpath: "[]",
      radius: 0,
      lng: 0,
      lat: 0,
      area: 0,
      loc: "",
    });
    setResetCounter((prev) => prev + 1); // also clear map drawing
  };

  return (
    <Styledashboard>
      <div style={{ padding: "16px", background: "#f0f2f5" }}>
        <Row gutter={[0, 16]} style={{ margin: 0 }}>
          {/* Left White Box */}
          <Col
            style={{
              flex: "0 0 350px",
              maxWidth: 350,
              minWidth: 350,
              paddingRight: 0,
              paddingLeft: 0,
            }}
          >
            {" "}
            <div className="d-flex justify-content-between align-items-center">
              <Card
                style={{ borderRadius: "12px", height: "100%", width: "100%" }}
              >
                <div className="container_for_header_subtwo">
                  <Back
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (fromEntityManagement) {
                        navigate("/entitymanagement");
                      } else {
                        navigate("/GeoFence");
                      }
                    }}
                  />{" "}
                  <p className="title">
                    {mode === "add"
                      ? "Create Fence"
                      : isEditing
                        ? "Edit Fence"
                        : "Details"}
                  </p>
                  {mode !== "add" && !isEditing && (
                    <Tooltip title={!updateAllowed ? "No permission" : ""}>
                      <ButtonFilled
                        type="primary"
                        disabled={!updateAllowed}
                        onClick={() => {
                          if (!updateAllowed) return;
                          setIsEditing(true);
                        }}
                      >
                        + Edit
                      </ButtonFilled>
                    </Tooltip>
                  )}
                </div>
                <p className="subtitle">
                  {!initialValues?.name ? "Add New Fence" : initialValues?.name}
                </p>{" "}
                {/* Form */}
                <Form
                  layout="vertical"
                  form={form}
                  initialValues={{
                    company:
                      userInfo?.MCID === 59
                        ? "0f0f2e76-4733-4388-9242-9ed7db003a1e"
                        : userInfo?.ECTSCompId,
                    fstyle: mode === "add" ? 1 : 2,
                    type:
                      userInfo?.MCID === 55
                        ? "cb092e5b-0367-46c3-98ef-89b779687efc"
                        : "",
                  }}
                >
                  <div className="box">
                    <Form.Item
                      label="Name"
                      name="name"
                      rules={[
                        {
                          required: true,
                          message: "Name is required",
                        },
                      ]}
                    >
                      <Input disabled={!isEditing} />
                    </Form.Item>

                    <Form.Item label="Number" name="number">
                      <Input disabled={!isEditing} />
                    </Form.Item>

                    <Form.Item
                      label="Company"
                      name="company"
                      rules={[
                        {
                          required: true,
                          message: "Company is required",
                        },
                      ]}
                      initialValue={
                        userInfo?.MCID === 59 ? undefined : userInfo?.ECTSCompId // preselect user's company
                      }
                    >
                      <Select
                        disabled={userInfo?.MCID !== 59} // only enabled for MCID 59
                        className="w-100"
                        showSearch
                        optionFilterProp="children"
                        allowClear={userInfo?.MCID === 59}
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {userInfo?.MCID === 59
                          ? companyList.map((type) => (
                              <Option
                                key={type.FAgentGUID}
                                value={type.FAgentGUID}
                              >
                                {type.FName}
                              </Option>
                            ))
                          : companyList
                              .filter(
                                (c) => c.FAgentGUID === userInfo?.ECTSCompId,
                              )
                              .map((type) => (
                                <Option
                                  key={type.FAgentGUID}
                                  value={type.FAgentGUID}
                                >
                                  {type.FName}
                                </Option>
                              ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Fence Style"
                      name="fstyle"
                      rules={[
                        {
                          required: true,
                          message: "Fence Style is required",
                        },
                      ]}
                    >
                      <Radio.Group
                        disabled={!isEditing}
                        onChange={handleFenceStyleChange}
                        value={form.getFieldValue("fstyle")}
                      >
                        <GreenRadio value="2">Circle</GreenRadio>
                        <GreenRadio value="1">Polygon</GreenRadio>
                      </Radio.Group>
                    </Form.Item>

                    <Form.Item
                      label="Type"
                      name="type"
                      rules={[
                        {
                          required: true,
                          message: "Type is required",
                        },
                      ]}
                      initialValue={
                        userInfo?.MCID === 55
                          ? "cb092e5b-0367-46c3-98ef-89b779687efc"
                          : undefined
                      }
                    >
                      <Select
                        disabled={
                          !isEditing ||
                          fromEntityManagement ||
                          userInfo?.MCID !== 59 ||
                          userInfo?.MCID === 55
                        }
                        className="w-100"
                        showSearch
                        optionFilterProp="children"
                        allowClear={!fromEntityManagement}
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {(userInfo?.MCID === 55
                          ? Reciepenttype.filter(
                              (type) =>
                                type.FGUID ===
                                "cb092e5b-0367-46c3-98ef-89b779687efc",
                            )
                          : Reciepenttype
                        ).map((item) => (
                          <Option key={item.FGUID} value={item.FGUID}>
                            {item.FName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="box">
                    <Form.Item label="Longitude" name="lng">
                      <Input disabled={!isEditing || fenceStyle === "1"} />
                    </Form.Item>

                    <Form.Item label="Latitude" name="lat">
                      <Input disabled={!isEditing || fenceStyle === "1"} />
                    </Form.Item>

                    <Form.Item label="Area (Km²)" name="area">
                      <Input disabled={!isEditing || fenceStyle === "1"} />
                    </Form.Item>

                    {/* Conditionally show Radius if Circle is selected */}
                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) => prev.fstyle !== curr.fstyle}
                    >
                      {({ getFieldValue, setFieldsValue }) =>
                        getFieldValue("fstyle") === "2" ? (
                          <Form.Item label="Radius (Km)*" name="radius">
                            <Input
                              disabled={!isEditing}
                              placeholder="3"
                              onChange={(e) => {
                                const newRadius =
                                  parseFloat(e.target.value) || 3;
                                setFieldsValue({ radius: newRadius });
                              }}
                            />
                          </Form.Item>
                        ) : null
                      }
                    </Form.Item>

                    <Form.Item label="Location" name="loc">
                      <Input.TextArea
                        rows={2}
                        disabled={!isEditing || fenceStyle === "1"}
                      />
                    </Form.Item>

                    <Form.Item label="Description" name="desc">
                      <Input disabled={!isEditing} />
                    </Form.Item>
                    <Form.Item name="fpath" initialValue="[]">
                      <Input type="hidden" />
                    </Form.Item>
                  </div>
                  {/* Action Buttons (only in Edit/Add mode) */}
                  {isEditing && (
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        style={{
                          cursor: "pointer",
                          marginTop: "22px",
                          backgroundColor: "#EF8686",
                          borderRadius: "26px",
                          padding: "9px 16px",
                          border: "none",
                          color: "white",
                          fontWeight: 500,
                        }}
                        onClick={() => form.resetFields()}
                      >
                        Reset
                      </Button>
                      <Buttontransparent
                        style={{ cursor: "pointer", marginTop: "20px" }}
                        onClick={() => {
                          setResetCounter((prev) => prev + 1); // bump counter on each click
                          form.setFieldsValue({
                            fpath: "[]",
                            radius: 0,
                            lng: 0,
                            lat: 0,
                            area: 0,
                            loc: "",
                          }); // clear form too
                        }}
                      >
                        Redraw
                      </Buttontransparent>
                      <ButtonFilled
                        style={{
                          cursor: "pointer",
                          marginTop: "20px",
                          marginLeft: "-4px",
                        }}
                        onClick={handleSave}
                        loading={loading}
                      >
                        Save
                      </ButtonFilled>
                    </div>
                  )}
                </Form>
              </Card>
            </div>
          </Col>

          {/* Right White Box */}
          <Col
            style={{ flex: 1, minWidth: 0, paddingLeft: 15, paddingRight: 0 }}
          >
            <div className="mapcomponent_subcontainer">
              <GoogleMapComponent
                showSearch={true}
                mapSize="large"
                resetTrigger={resetCounter}
                className="map_container_three"
                drawingMode={
                  form.getFieldValue("fstyle") === "1" ? "polygon" : "circle"
                }
                fenceData={fenceList}
                fenceStyle={form.getFieldValue("fstyle") || currentFenceStyle}
                radius={parseFloat(form.getFieldValue("radius")) || 3}
                onPathChange={(points) => {
                  // store polygon path without closing duplication
                  form.setFieldsValue({ fpath: points || "[]" });
                }}
                initialPolygon={
                  location.state?.FPath
                    ? JSON.parse(location.state.FPath)
                    : null
                }
                onPolygonDraw={async (points) => {
                  if (points.length > 0) {
                    const firstPoint = points[0];
                    const lastPoint = points[points.length - 1];

                    // Ensure polygon is closed
                    const isClosed =
                      firstPoint.lat === lastPoint.lat &&
                      firstPoint.lng === lastPoint.lng;
                    const closedPoints = isClosed
                      ? points
                      : [...points, firstPoint];

                    // Clean path (remove duplicate last point)
                    const fPathClean = closedPoints.slice(0, -1);

                    // Convert to Turf polygon
                    const turfPolygon = turf.polygon([
                      closedPoints.map((p) => [p.lng, p.lat]),
                    ]);

                    //  Area in square meters
                    const areaSqMeters = turf.area(turfPolygon);

                    // Convert to km²
                    const areaSqKm = areaSqMeters / 1_000_000;

                    // Fetch location name
                    const locName = await fetchLocation(
                      firstPoint.lat,
                      firstPoint.lng,
                    );

                    form.setFieldsValue({
                      area: Math.round(areaSqKm * 100) / 100 || 0, // round to 2 decimals
                      loc: locName || "",
                      fpath: fPathClean || "[]",
                      radius: 0,
                      lng: firstPoint.lng || 0,
                      lat: firstPoint.lat || 0,
                    });
                  }
                }}
                onCircleDraw={async (circleData) => {
                  if (circleData) {
                    // Fetch location name
                    const locName = await fetchLocation(
                      circleData.center.lat,
                      circleData.center.lng,
                    );

                    form.setFieldsValue({
                      area: Math.round(circleData.area * 100) / 100 || 0, // round to 2 decimals
                      loc: locName || "",
                      fpath: JSON.stringify([circleData.center]), // Store center point
                      radius: circleData.radius,
                      lng: circleData.center.lng || 0,
                      lat: circleData.center.lat || 0,
                    });
                  }
                }}
                isEditing={mode === "add" || isEditing}
              />
            </div>
          </Col>
        </Row>
      </div>
    </Styledashboard>
  );
}

export default GeoDetails;
